export default {
  // <-------------------- Shared -------------------->
  home: "/",
  activity: "/activity",
  epicenter: "/epicenter",
  glossaryVideos: "/glossary_videos",
  videosAndGames: "/videos_and_games",
  help: "/help",
  settings: "/settings",
  studentAssignment: "/student_assignments/:id",
  bitsbox: "/bitsbox",
  streamingResources: "/media_assets",
  streamingDashboard: "/media_assets/dashboard",
  streamingResource: "/media_assets/:resourceId",
  eBookList: "/e_book",
  eBook: "/e_book/:title/:id",
  // <-------------------- Student -------------------->
  assignments: "/assignments",
  grades: "/student_assignments",
  studentNotes: "/student_notes",
  studentAccount: "/student_account/:id/edit",
  learningResources: "/learning_resources",
  learningResource: "/learning_resources/:id",
  learningResourceDisplayElement: "/learning_resources/:id/display_element",

  // <-------------------- Teacher -------------------->
  students: "/students",
  planner: "/lesson_planner",
  lessonPlannerPrint: "/lesson_planner/print",
  lessonPlansNew: "/lesson_plans/new",
  preferences: "/teachers/:id/edit",
  studentsAssignments: "/students/assignments",
  teacherSectionAssignments: "/teacher_section_assignments",
  teacherSectionAssignment: "/teacher_section_assignments/:id",
  teacherSectionAssignmentSnapshot: "/teacher_section_assignments/:id/snapshot",
  studentsArchived: "/students/archived",
  teacherSectionsNew: "/teacher_sections/new",
  teacherSection: "/teacher_sections/:id",
  teacherSectionsEdit: "/teacher_sections/:id/edit",
  teacherSectionShowStudents:
    "/teacher_sections/:teacherSectionId/show_students",
  teacherSectionStudent:
    "/teacher_sections/:teacherSectionId/students/:studentId",
  teacherSectionStudentNew: "/teacher_sections/:teacherSectionId/students/new",
  teacherSectionStudentEdit:
    "/teacher_sections/:teacherSectionId/students/:studentId/edit",
  teacherSections: "/teacher_sections",
  teacherSectionsTeacherSectionAssignment:
    "/teacher_sections/:teacherSectionId/teacher_section_assignments/:teacherSectionAssignmentId",
  teacherSectionAssignmentsTeacherAssessment:
    "/teacher_section_assignments/:id/teacher_assessment",
  teacherSectionsArchivedAssignments:
    "/teacher_sections/:teacherSectionId/teacher_section_assignments/archived",
  teacherSectionsAssignments:
    "/teacher_sections/:teacherSectionId/teacher_section_assignments/:assignmentId",
  notes: "/notes",

  rootStandards: "/standards",
  standards: "/standards/:standardId?",

  scopes: "/scopes",
  scope: "/scopes/:scopeId",
  scopeElement: "/scopes/:scopeId/elements/:elementId",
  scopeSection: "/scopes/:scopeId/sections/:sectionId",
  scopeOutline: "/scopes/:scopeId/:sectionTab",
  scopeNav: "/scopes/:scopeId?/sections/:sectionId?/elements/:elementId?",
  bookmarks: "/scopes/bookmarks",
  bookmarksNewFolder: "/scopes/bookmarks/new",
  bookmarksEditFolder: "/scopes/bookmarks/:id/edit",
  toolbox: "/scopes/teacher_toolbox",
  section: "/scopes/:scopeId/sections/:sectionId",
  element: "/scopes/:scopeId/elements/:elementId",

  stemcoachDomains: "/stemcoach_domains",
  stemcoachDomain: "/stemcoach_domains/:domainId",
  stemcoachAction: "/stemcoach_domains/:domainId/stemcoach_actions/:actionId/*",
  stemcoachActionResources: "/stemcoach_resources",
  stemcoachActionFaq: "/stemcoach_faqs",
  stemcoachActionVideos: "/stemcoach_videos",

  teacherAssessments: "/teacher_assessments",
  teacherAssessmentsArchived: "/teacher_assessments/archived",
  teacherAssessmentsPending: "/teacher_assessments/pending",
  teacherAssessmentsNew: "/teacher_assessments/new",
  teacherAssessmentsEdit: "/teacher_assessments/:id/edit",
  teacherAssessment: "/teacher_assessments/:assessmentId",
  teacherAssessmentShare:
    "/teacher_assessments/:assessmentId/teacher_assessment_shares/new",
  packageAssessments: "/package_assessments",
  packageAssessment: "/package_assessments/:id",

  teacherSectionNewAssignment: "/teacher_section_assignments/new",
  teacherSectionAssignmentResult: "/teacher_section_assignment_results/:id",
  teacherSectionStudentResponses: "/teacher_section_student_responses/:id",
  teacherSectionStudentResponse:
    "/teacher_section_student_response/:id/student/:studentId",
  teacherSectionEditAssignment: "/teacher_section_assignments/:id/edit",
  teacherSectionSnapshotAssignment: "/teacher_section_assignments/:id/snapshot",
  studentAssignmentReassignGrader: "/student_assignments/:id/reassign_grader",

  campaignStaffAssignment: "/campaign_staff_assignment",

  // <-------------------- District Assignments -------------------->
  districtAssignment: "/district_assignments/:id",
  districtStudentAssignment: "/district_student_assignments/:id",
  districtAssignmentSnapshot: "/district_assignments/:id/snapshot",
  districtAssignmentStudentResponses:
    "/district_assignments/:id/student_responses",

  // <-------------------- Visitor -------------------->
  externalSessionAuthenticate: "/external-sessions/authenticate",
  offlineLogin: "/offline-login",

  // <-------------------- LTI -------------------->

  lti: {
    error: "/lti/error",
    canvas: {
      searchToolScopes: "/lti/canvas/search/scopes" /* type=single|multiple */,
      searchToolAssessmentPackages: "/lti/canvas/search/assessment_packages",
      searchToolScope: "/lti/canvas/search/scope/:scopeId",
      searchToolElement: "/lti/canvas/search/scope/:scopeId/element/:elementId",
      searchToolAssessmentPackage: "/lti/canvas/search/assessment_package/:id",
      preview:
        "/lti/canvas/preview/:elementId" /* ?type=element|packageAssessment */,
      review: "/lti/canvas/review/:id",
      studentAssignment: "/lti/canvas/student_assignment/:id",
    },
    schoology: {
      teacherSectionAssignments:
        "/lti/schoology/teacher_section_assignments/:tsaId",
      searchToolScopes:
        "/lti/schoology/search/scopes" /* type=single|multiple */,
      searchToolAssessmentPackages: "/lti/schoology/search/assessment_packages",
      searchToolScope: "/lti/schoology/search/scope/:scopeId",
      searchToolElement:
        "/lti/schoology/search/scope/:scopeId/element/:elementId",
      searchToolAssessmentPackage:
        "/lti/schoology/search/assessment_package/:id",
      preview:
        "/lti/schoology/preview/:elementId" /* ?type=element|packageAssessment */,
      review: "/lti/schoology/review/:id",
      studentAssignment: "/lti/schoology/student_assignment/:id",
    },
  },

  // <-------------------- Other Scores -------------------->
  otherScore: "/students/:id/other_score",
};
